export default {
  bookmarksCount: (state) => (id) => {
    if (!state.bookmarksCounts) return 0;

    return state.bookmarksCounts[id];
  },
};
